import { plainToInstance, Type } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { TaskStatus } from '@core/entities/task/TaskBase/types'
import { TaskTemplatePriorityType } from '@core/entities/task/TaskTemplateProperties'
import { TemplateTargetResult } from '@core/entities/notifications/TemplateTargetResult'
import { ITaskTargetResult } from './ITaskTargetResult'

export class TaskTargetResult extends Entity<ITaskTargetResult> {
  id: number
  organisationId: number
  priority: TaskTemplatePriorityType
  status: TaskStatus
  dueDate?: string
  summary?: string

  @Type(() => TemplateTargetResult)
  template: TemplateTargetResult

  public static new(payload: ITaskTargetResult): TaskTargetResult {
    return plainToInstance(TaskTargetResult, payload)
  }
}
